import { connect } from 'react-redux';
import {actions} from '../../../../../redux/modules/laboratorio';
import AnalisisVer from './AnalisisVer';

const mstp = state => {
    const { me } = state.login;

    return {
        ...state.laboratorio,
        me,
    }
};

const mdtp = {
    ...actions
};

export default connect(mstp, mdtp)(AnalisisVer)
